import { ReservationContextInterface } from "@/contexts/reservation_state";

export function saveReservationContext(context: ReservationContextInterface) {
  let key = `reservation_context`;
  localStorage.setItem(key, JSON.stringify(context));
}

export function getReservationContext(): ReservationContextInterface | null {
  let key = `reservation_context`;
  let context = localStorage.getItem(key);
  if (context) {
    return JSON.parse(context) as ReservationContextInterface;
  }
  return null;
}

export function clearReservationContext() {
  let key = `reservation_context`;
  localStorage.removeItem(key);
}
